<template>
<section :style="{width,height}" class="login-wrapper">
  <section class="login-layer">
    <header class="login-header">
      <section class="login-system-title">
        <h1 class="chinese-title">环境空气自动监测系统现场质控检查平台</h1>
        <!--        <h3 class="english-title">ATMOSPHERIC MONITORING SYSTEM</h3>-->
      </section>
    </header>

    <section class="login-body">
      <section class="login-panel">
        <el-form
          ref="form"
          :model="model"
          :rules="rules"
          hide-required-asterisk
          class="login-form"
          @input.native="errInfo = ''"
          @submit.native.prevent="handleLogin"
        >
          <section class="login-form-header">
            <h2 class="welcome-text">欢迎使用</h2>
            <h4 class="login-text">登录</h4>
          </section>

          <section class="login-form-body">
            <section class="login-request-err">
              <span class="form-err-msg">{{errInfo}}</span>
            </section>

            <el-form-item label="用户名" prop="username">
              <el-input v-model="model.username" />
            </el-form-item>

            <el-form-item label="密码" prop="password">
              <el-input v-model="model.password" type="password" />
            </el-form-item>
          </section>

          <section class="login-form-footer">
            <button class="login-form-button">确定</button>
          </section>
        </el-form>
      </section>
    </section>

    <footer class="login-footer">
      <h3 class="login-support-company">上海贝瑟环保科技有限公司/上海墨而信息科技有限公司</h3>
    </footer>
  </section>
</section>
</template>

<script>
import CryptoJS from 'crypto-js'

const SECRET_KEY = 'MORE.BEISE'

export default {
  name: 'Login',
  data () {
    return {
      model: {
        username: '',
        password: ''
      },
      rules: {
        username: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      errInfo: '',
      width: '100vw',
      height: '100vh'
    }
  },
  methods: {
    handleLogin () {
      this.$refs.form.validate(flag => {
        if (flag) {
          this.login()
        }
      })
    },
    login () {
      let model = Object.assign({}, this.model)
      model.password = CryptoJS.DES.encrypt(model.password, CryptoJS.enc.Utf8.parse(SECRET_KEY), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString()

      this.$api.Profile.login(model).then(token => {
        this.$store.commit('Profile/setToken', token)
      }).catch(error => {
        this.errInfo = error.message
      })
    },
    onWindowResize () {
      if (/^https?:$/.test(location.protocol)) {
        this.width = '100vw'
        this.height = '100vh'
      } else {
        this.width = `${screen.width}px`
        this.height = `${screen.height}px`
      }
    }
  },
  created () {
    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize, true)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize, true)
  }
}
</script>

<style lang="scss" scoped>
.login-wrapper {
  background: {
    image: url("../../assets/imgs/main-bg.jpg");
    size: cover;
    position: center;
    repeat: no-repeat;
    attachment: fixed;
  };
  overflow: auto;

  .login-layer {
    position: relative;
    width: 52rem;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .login-header,
  .login-footer {
    height: calc(50vh - 15rem);
  }

  .login-header {
    position: relative;
    min-height: 5rem;

    .login-system-title {
      position: absolute;
      top: 0;
      bottom: 0;
      height: 3.6em;
      margin: auto 0;
    }

    .chinese-title {
      font-size: 1.8rem;
      margin: 0;
      color: #FFFFFF;
    }

    .english-title {
      font-size: 1.1rem;
      margin: .22727272727272727em 0 0;
      line-height: .7727272727272727;
      color: hsla(0, 0%, 100%, .59);
    }
  }

  .login-body {
    .login-panel {
      width: 100%;
      height: 30rem;
      padding-left: 31.85rem;
      background: {
        color: #FFFFFF;
        image: url("../../assets/imgs/login.jpg");
        size: contain;
        postion: 0 0;
        repeat: no-repeat;
      }
    }

    .login-form {
      padding: 5.4rem 2.6rem 6.7rem 2.55rem;

      .welcome-text {
        font: {
          size: 1.6em;
          weight: 500;
        }
        line-height: 1.40625;
        margin: 0;
        padding: 0;
      }

      .login-text {
        font: {
          size: .9rem;
          weight: 500;
        }
        line-height: 1.3888888888888888;
        margin: .3888888888888889em 0 0;
      }

      .login-form-body {
        position: relative;
        padding-top: 3.15rem;

        .login-request-err {
          position: absolute;
          top: 1.575rem;
          width: 100%;
          transform: translate(0, -50%);
        }

        .el-form-item {
          position: relative;
          height: 2.3rem;
          margin-bottom: 1.7rem;

          /deep/ {
            .el-form-item__label {
              position: absolute;
              top: 0;
              bottom: 0;
              left: 1.0769230769230769em;
              font-size: .8em;
              height: 1.3846153846153846em;
              line-height: 1.3846153846153846;
              margin: auto 0;
              color: #8EA7BF;
              z-index: 1;
            }

            .el-form-item__content {
              height: 100%;
              line-height: unset;
            }

            .el-input {
              height: 100%;
            }

            .el-input__inner {
              font-size: .8rem;
              width: 100%;
              height: 100%;
              line-height: 1.2857142857142858;
              padding: .6428571428571429em .6428571428571429em .6428571428571429em 5.071428571428571em;
              border: 1px solid #6BA7EB {
                radius: 4px;
              };
              box-shadow: inset 0 0 0 999px #F1F9FF;
            }
          }
        }
      }

      .login-form-footer {
        margin-top: 3.4rem;

        .login-form-button {
          font-size: .8rem;
          width: 100%;
          height: 3em;
          border: 0 {
            radius: 4px;
          };
          background-image: linear-gradient(180deg, #5686FF 0%, #0ECBFD 100%);
          box-shadow: 0 7px 12px 0 rgba(0, 129, 255, .20);
          color: #FFFFFF;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #0ECBFD 0%, #5686FF 100%);
          }

          &:active {
            background-image: linear-gradient(180deg, #5686FF 0%, #0ECBFD 100%);
            box-shadow: none;
          }
        }
      }
    }
  }

  .login-footer {
    position: relative;
    min-height: 5em;
    padding-bottom: 2.5em;
    overflow: hidden;

    .login-support-company {
      position: absolute;
      font-size: 1.1em;
      bottom: 2.272727272727273em;
      width: 100%;
      margin: 0;
      text-align: center;
      color: #FFFFFF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Profile/Login.vue